/* @generated — do not edit directly */
// Generated by packages/schemas/scripts/generate-tool-metadata.ts

import { z } from "zod";

const knownMcpNextDevtoolsBrowserEvalToolMetadataSchema = z.object({
  iconKey: z.literal("nextDevtools"),
  input: z.object({ task: z.string().optional() }),
  output: z.object({}),
});
const knownMcpNextDevtoolsNextjsCallToolMetadataSchema = z.object({
  iconKey: z.literal("nextDevtools"),
  input: z.object({
    args: z.string().optional(),
    port: z.string().optional(),
    toolName: z.string().optional(),
  }),
  output: z.object({}),
});
const knownMcpNextDevtoolsNextjsDocsToolMetadataSchema = z.object({
  iconKey: z.literal("nextDevtools"),
  input: z.object({
    project_path: z.string().optional(),
    topic: z.string().optional(),
  }),
  output: z.object({}),
});
const knownMcpNextDevtoolsNextjsIndexToolMetadataSchema = z.object({
  iconKey: z.literal("nextDevtools"),
  input: z.object({ port: z.string().optional() }),
  output: z.object({}),
});

const knownMcpNextDevtoolsToolMetadataSourceSchema = z.object({
  browser_eval: knownMcpNextDevtoolsBrowserEvalToolMetadataSchema,
  nextjs_call: knownMcpNextDevtoolsNextjsCallToolMetadataSchema,
  nextjs_docs: knownMcpNextDevtoolsNextjsDocsToolMetadataSchema,
  nextjs_index: knownMcpNextDevtoolsNextjsIndexToolMetadataSchema,
});

export const knownNextDevtoolsMcpToolMetadataRegistrySchema =
  knownMcpNextDevtoolsToolMetadataSourceSchema.describe(
    "KnownNextDevtoolsMcpToolMetadataRegistry",
  );
